__turbopack_context__.v({
  "className": "instrument_serif_65b7d611-module__p3g0dW__className",
});
